import { useTranslation } from "react-i18next";
import { DisplayUtils } from "../../utils";
import { NavMenu } from "../../components";


export const HowWorks = () => {
  const { t } = useTranslation();

  return (
    <NavMenu>
      <div className="Info">
        <div className="w-100 d-flex justify-content-center">
          {!DisplayUtils.isMobile() ? (
            <img src="/misc/icons/complete_logo_white.svg" alt="shop-icon" className="Info__logo" />
          ) : (
            <div className="Info__title">
              <h1>{t('HowWorks.title')}</h1>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-center">
          <div className="Info__container">
            {!DisplayUtils.isMobile() && (
              <div className="Info__container__title">
                <h1 className="Info__container__title__text">{t('HowWorks.title')}</h1>
              </div>
            )}
            <div className="Info__container__data">
              <div className="contenido" dangerouslySetInnerHTML={{ __html: t('HowWorks.description') }} />
            </div>
          </div>
        </div>
      </div>
    </NavMenu>
  );
};